import { useEffect, useState } from "react";
import "./CustomNotify.scss";
import { useGlobalState } from "../../context/GlobalStateContext";

const STORAGE_KEY = "notify-banner-hidden";

const CustomNotify = () => {
  const [visible, setVisible] = useState(false);
  const { language } = useGlobalState();
  useEffect(() => {
    const hidden = localStorage.getItem(STORAGE_KEY);
    if (!hidden) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="notify-banner">
      <div className="notify-banner__content">
        {language === "ru" ? (
          <>
            <div className="notify-banner__text">
              <strong>Проверьте доступ Paylater в OneID</strong>

              <p>
                Если доступ к персональным данным в OneID отключён, оформление
                рассрочки и другие операции могут работать с задержками.
              </p>
            </div>

            <div className="notify-banner__actions">
              <a href="/instructions" className="notify-banner__link">
                Открыть инструкцию
              </a>

              <button className="notify-banner__close" onClick={handleClose}>
                ✕
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="notify-banner__text">
              <strong>OneID’da Paylater’ga kirish huquqini tekshiring.</strong>

              <p>
                Agar OneID’da shaxsiy ma’lumotlarga ruxsat o‘chirilgan bo‘lsa,
                muddatli to'lovni rasmiylashtirish va boshqa amallar kechikib
                ishlashi mumkin.
              </p>
            </div>

            <div className="notify-banner__actions">
              <a href="/instructions" className="notify-banner__link">
                Ko'rsatmalarni oching
              </a>

              <button className="notify-banner__close" onClick={handleClose}>
                ✕
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomNotify;
